export default [
   {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('@/views/dashboard/index.vue'),
      meta: {
         resource: 'dashboard',
         action: 'read',
         pageTitle: 'Dashboard',
         breadcrumb: [
            {
               text: 'Dashboard',
               active: true,
            },
         ],
      },
   },
   {
      path: '/dashboard/oss',
      name: 'dashboard-oss',
      component: () => import('@/views/dashboard/Oss.vue'),
      meta: {
         resource: 'dashboard',
         action: 'read',
         pageTitle: 'Dashboard OSS',
         breadcrumb: [
            {
               text: 'Dashboard',
               active: false,
            },
            {
               text: 'OSS',
               active: true,
            },
         ],
      },
   },
   {
      path: '/dashboard/simbg',
      name: 'dashboard-simbg',
      component: () => import('@/views/dashboard/Simbg.vue'),
      meta: {
         resource: 'dashboard',
         action: 'read',
         pageTitle: 'Dashboard SIMBG',
         breadcrumb: [
            {
               text: 'Dashboard',
               active: false,
            },
            {
               text: 'SIMBG',
               active: true,
            },
         ],
      },
   },
   {
      path: '/dashboard/mppd',
      name: 'dashboard-mppd',
      component: () => import('@/views/dashboard/Mppd.vue'),
      meta: {
         resource: 'dashboard',
         action: 'read',
         pageTitle: 'Dashboard MPPD',
         breadcrumb: [
            {
               text: 'Dashboard',
               active: false,
            },
            {
               text: 'MPPD',
               active: true,
            },
         ],
      },
   },
   {
      path: '/dashboard/sicantik',
      name: 'dashboard-sicantik',
      component: () => import('@/views/dashboard/Sicantik.vue'),
      meta: {
         resource: 'dashboard',
         action: 'read',
         pageTitle: 'Dashboard SICANTIK',
         breadcrumb: [
            {
               text: 'Dashboard',
               active: false,
            },
            {
               text: 'SICANTIK',
               active: true,
            },
         ],
      },
   },
   {
      path: '/dashboard/lkpm',
      name: 'dashboard-lkpm',
      component: () => import('@/views/dashboard/Lkpm.vue'),
      meta: {
         resource: 'dashboard',
         action: 'read',
         pageTitle: 'Dashboard LKPM',
         breadcrumb: [
            {
               text: 'Dashboard',
               active: false,
            },
            {
               text: 'LKPM',
               active: true,
            },
         ],
      },
   },
   {
      path: '/dashboard/skm',
      name: 'dashboard-skm',
      component: () => import('@/views/dashboard/Skm.vue'),
      meta: {
         resource: 'dashboard',
         action: 'read',
         pageTitle: 'Dashboard SKM',
         breadcrumb: [
            {
               text: 'Dashboard',
               active: false,
            },
            {
               text: 'SKM',
               active: true,
            },
         ],
      },
   },
]
